import {
  GraphVisualizationExportInput,
  GraphVisualizationExportResponse,
  LucidchartAnalyzeDocumentResponse,
  LucidChartPickerTokenResponse,
  LucidChartSettingsResponse,
} from '@ardoq/api-types/integrations';
import { ApiResponse } from '../types';
import { fetchJson, Method, toRequestOptions } from '../api';
import {
  PersistedExternalDocument,
  ExternalDocumentTargetType,
  ArdoqId,
} from '@ardoq/api-types';
import { Maybe } from '@ardoq/common-helpers';

const BASE_URL = '/api/integrations/lucidchart';

const embedToken = (
  externalDocumentId: string | null
): ApiResponse<LucidChartPickerTokenResponse> => {
  const request = new Request(
    `${BASE_URL}/embed-token`,
    toRequestOptions(Method.POST, { externalDocumentId })
  );
  return fetchJson(request);
};

const pickerToken = (): ApiResponse<LucidChartPickerTokenResponse> => {
  const request = new Request(
    `${BASE_URL}/picker-token`,
    toRequestOptions(Method.GET, null)
  );
  return fetchJson(request);
};

const exportVisualization = (
  data: GraphVisualizationExportInput
): ApiResponse<GraphVisualizationExportResponse> => {
  const request = new Request(
    `${BASE_URL}/export-visualization`,
    toRequestOptions(Method.POST, data)
  );
  return fetchJson(request);
};

const linkDocument = (
  documentId: string,
  payload: {
    targetId: string;
    targetType: ExternalDocumentTargetType;
    scenarioId: Maybe<ArdoqId>;
  }
): ApiResponse<PersistedExternalDocument> => {
  const request = new Request(
    `${BASE_URL}/document/${documentId}/link`,
    toRequestOptions(Method.POST, payload)
  );
  return fetchJson(request);
};

const settings = (): ApiResponse<LucidChartSettingsResponse> => {
  const request = new Request(
    `${BASE_URL}/settings`,
    toRequestOptions(Method.GET, null)
  );
  return fetchJson(request);
};

const analyzeDocument = (
  documentId: string,
  payload: {
    workspaceIds: ArdoqId[];
    customPrompt: string | null;
    inferWorkspaces: boolean;
  }
): ApiResponse<LucidchartAnalyzeDocumentResponse> => {
  const request = new Request(
    `${BASE_URL}/document/${documentId}/analyze`,
    toRequestOptions(Method.POST, payload)
  );
  return fetchJson(request);
};

export const integrationsLucidChartApi = {
  embedToken,
  pickerToken,
  exportVisualization,
  linkDocument,
  settings,
  analyzeDocument,
};
